import React from 'react';
import { Box, Text } from '@mantine/core';
import { IValidateTicketResponse } from '../../api/event';

interface ScannedHistoryProps {
    localHistory: IValidateTicketResponse[];
    t: (key: string) => string;
}

const ScannedHistory: React.FC<ScannedHistoryProps> = ({ localHistory, t }) => {
    return (
        <Box>
            {localHistory && localHistory.map((history, index) => (
                <Box
                    key={index}
                    style={{
                        borderLeft: '4px solid #099268',
                        borderTopLeftRadius: '5px',
                        borderBottomLeftRadius: '5px',
                        paddingLeft: '6px'
                    }}
                >
                    <Text size="sm" mb="xs" fw={500} mt={index !== 0 ? 11 : 0}>
                        <span>
                            {history.id}
                            <span className="ticket-slash-spacing">/</span>
                            {history?.key.split(':')[0]}
                            <span className="ticket-slash-spacing">/</span>
                            {t("seatValidate.columns.row")} {history?.key.split(':')[1]}
                            <span className="ticket-slash-spacing">/</span>
                            {t("seatValidate.columns.seat")} {history?.key.split(':')[2]}
                        </span>
                    </Text>
                </Box>
            ))}
        </Box>
    );
};

export default ScannedHistory;
